module.exports = __webpack_public_path__ + "img/step5.14.887719cd.png";